import React from "react";

const ContactItem = ({ icon: IconComponent, title, link, value }) => {
  return (
    <li className="contact-item">
      <div className="icon-box">
        <div className="ion-icon">
          <IconComponent />
        </div>
      </div>

      <div className="contact-info">
        <p className="contact-title">{title}</p>

        {link ? (
          <a
            href={link}
            className="contact-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {value}
          </a>
        ) : (
          <span className="contact-text">{value}</span>
        )}
      </div>
    </li>
  );
};

export default ContactItem;
